export const tokens = {
    group: {
        radius: 10,
    },
    label: {
        gap: 6,
        padding: 10,
        size: 13,
    },
    badge: {
        size: 18,
    },
    count: {
        padding: 4,
        size: 10,
    },
    toggleAction: {
        size: 40,
        bubbleSize: 20,
        iconSize: 10,
    },
    content: {
        padding: 10,
        scrollHeight: 200,
    },
};
